import { SxProps, Theme } from '@mui/material';
import { Base, Content, Icon } from './styled';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

interface Props {
  children: React.ReactNode;
  icon?: React.ReactNode;
  sx?: SxProps<Theme> | undefined;
}
export default function NotificationBase({ children, icon, sx }: Props) {
  return (
    <Base sx={sx}>
      <Icon>{icon ? icon : <PriorityHighIcon fontSize="small" />}</Icon>
      <Content>{children}</Content>
    </Base>
  );
}
